import { Component, signal, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { animate, style, transition, trigger } from '@angular/animations';
import { TopNavComponent } from '../components/top-nav/top-nav.component';
import { SideNavComponent } from '../components/side-nav/side-nav.component';
import { FooterComponent } from '../components/footer/footer.component';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    RouterLink,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    TopNavComponent,
    SideNavComponent,
    FooterComponent,
  ],
  animations: [
    trigger('routeFadeSlide', [
      transition('* <=> *', [
        style({ opacity: 0.99 }),
        animate('80ms ease-out', style({ opacity: 1 }))
      ])
    ])
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private auth = inject(AuthService);
  protected readonly title = signal('MAQI');
  readonly year = new Date().getFullYear();

  // Expose auth state for template
  readonly user = this.auth.user;
  readonly isAuthenticated = this.auth.isAuthenticated;
  readonly authResolved = this.auth.authResolved;
  readonly isAdmin = this.auth.isAdmin;

  logout() { this.auth.logout(); }

  prepareRoute(outlet: RouterOutlet) {
    if (!outlet || !outlet.isActivated) return null;
    return outlet.activatedRoute.snapshot.routeConfig?.path || 'home';
  }
}
